"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.massageTagsForSearch = exports.buildTagsArray = exports.DEFAULT_TAGS = exports.DEFAULT_STARTING_TAGS = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var DEFAULT_TAGS = [{
  name: "att ⅓",
  category: "Location",
  third: "offensive",
  tag_name: "offensive"
}, {
  name: "mid ⅓",
  category: "Location",
  third: "middle",
  tag_name: "middle"
}, {
  name: "def ⅓",
  category: "Location",
  third: "defensive",
  tag_name: "defensive"
}, {
  name: "Touch Chain",
  category: "Description",
  type: "touch chain",
  tag_name: "touch-chain"
}, {
  name: "Box",
  category: "Description",
  type: "home-box",
  tag_name: "home-box"
}, {
  name: "Opponent Box",
  category: "Description",
  type: "away-box",
  tag_name: "away-box"
}, {
  name: "Goal",
  category: "Description",
  type: "key",
  tag_name: "goal",
  tag_side: "home"
}, {
  name: "Away Goal",
  category: "Description",
  type: "key",
  tag_name: "goal",
  tag_side: "away"
}, {
  name: "Progression",
  category: "Description",
  type: "packing",
  tag_name: "packing",
  tag_side: "home"
}, {
  name: "Defensive Breakdown",
  category: "Description",
  type: "away-packing",
  tag_name: "packing",
  tag_side: "away"
}];
exports.DEFAULT_TAGS = DEFAULT_TAGS;
var DEFAULT_STARTING_TAGS = [{
  name: "att ⅓",
  category: "Location",
  third: "offensive",
  tag_name: "offensive"
}, {
  name: "Touch Chain",
  category: "Description",
  type: "touch chain",
  tag_name: "touch-chain"
}];
exports.DEFAULT_STARTING_TAGS = DEFAULT_STARTING_TAGS;

var buildTagsArray = function buildTagsArray(type, keywords, thirds) {
  var includeEntireTag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var superset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
  var sportType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "soccer";
  var result = new Set(); // If we're dealing with soccer moment

  if (sportType === "soccer") {
    // Touch chains
    if (type.includes("touch chain") || keywords.includes("touch-chain")) {
      var newElement = includeEntireTag ? superset.find(function (t) {
        return t.name === "Touch Chain";
      }) : "touch chain";
      result.add(newElement);
    } // Home Box


    if (keywords.includes("home box")) {
      var _newElement = includeEntireTag ? superset.find(function (t) {
        return t.name === "Box";
      }) : "box";

      result.add(_newElement);
    } // Away box


    if (keywords.includes("away-box")) {
      var _newElement2 = includeEntireTag ? superset.find(function (t) {
        return t.name === "Opponent Box";
      }) : "opponent box";

      result.add(_newElement2);
    } // Goal


    if (keywords.includes("goal") && keywords.includes("home") || keywords.includes("Goal") && keywords.includes("home") || thirds.includes("offense") && type.includes("key")) {
      var _newElement3 = includeEntireTag ? superset.find(function (t) {
        return t.name === "Goal";
      }) : "goal";

      result.add(_newElement3);
    } // Away Goal


    if (keywords.includes("goal") && keywords.includes("away") || keywords.includes("Goal") && keywords.includes("away") || thirds.includes("defense") && type.includes("key")) {
      var _newElement4 = includeEntireTag ? superset.find(function (t) {
        return t.name === "Away Goal";
      }) : "away goal";

      result.add(_newElement4);
    } // Progression


    if (keywords.includes("packing") && keywords.includes("home") || type.includes("packing") && !type.includes("away")) {
      var _newElement5 = includeEntireTag ? superset.find(function (t) {
        return t.name === "Progression";
      }) : "progression";

      result.add(_newElement5);
    } // Defensive breakdown


    if (keywords.includes("packing") && keywords.includes("away") || type.includes("away-packing")) {
      var _newElement6 = includeEntireTag ? superset.find(function (t) {
        return t.name === "Defensive Breakdown";
      }) : "defensive breakdown";

      result.add(_newElement6);
    } // Offensive


    if (keywords.includes("offensive")) {
      result.add("att ⅓");
    } // Defensive


    if (keywords.includes("defensive")) {
      result.add("def ⅓");
    } // Middle


    if (keywords.includes("middle")) {
      result.add("mid ⅓");
    } // If we're dealing with baseball moment

  } else if (sportType === "baseball") {
    if (keywords.includes("home-to-first")) {
      result.add("baserunner");
    }

    if (keywords.includes("at-bat")) {
      result.add("at bat");
    }

    if (keywords.includes("hit")) {
      result.add("hit");
    }

    if (keywords.includes("pitcher")) {
      result.add("pitcher");
    }
  } // Baseball


  var uniqueResult = _toConsumableArray(new Set(result));

  return uniqueResult;
};

exports.buildTagsArray = buildTagsArray;

var massageTagsForSearch = function massageTagsForSearch(tags) {
  var massagedTags = new Set(); // touch chains

  if (tags.includes("touch chain")) {
    massagedTags.add(["touch", "touch-chain"]);
  } // home box


  if (tags.includes("box")) {
    massagedTags.add("home-box");
  } // away box


  if (tags.includes("opponent box")) {
    massagedTags.add("away-box");
  } // Goal


  if (tags.includes("goal")) {
    massagedTags.add(["goal"]);
  } // Away Goal


  if (tags.includes("away goal")) {
    massagedTags.add([["goal", "away"], ["defensive", "key"], ["Goal", "away"]]);
  } // Progression


  if (tags.includes("progression")) {
    massagedTags.add([["packing", "home"], ["packing", "away"]]);
  } // Defensive Breakdown


  if (tags.includes("defensive breakdown")) {
    massagedTags.add(["away-packing", ["packing", "away"]]);
  } // Offensive


  if (tags.includes("att ⅓") || tags.includes("off ⅓")) {
    massagedTags.add("offensive");
  } // Defensive


  if (tags.includes("def ⅓")) {
    massagedTags.add("defensive");
  } // Middle 


  if (tags.includes("mid ⅓")) {
    massagedTags.add("middle");
  } // Touch


  if (tags.includes("touch")) {
    massagedTags.add("touch");
  } // Touch Chain


  if (tags.includes("touch-chain")) {
    massagedTags.add("touch-chain");
  } // Dive


  if (tags.includes("dive")) {
    massagedTags.add("dive");
  } // Baseball
  // Hit


  if (tags.includes("hit")) {
    massagedTags.add("hit");
  } // Single


  if (tags.includes("single")) {
    massagedTags.add("single");
  } // Double


  if (tags.includes("double")) {
    massagedTags.add("double");
  } // Triple


  if (tags.includes("triple")) {
    massagedTags.add("triple");
  } // Homerun


  if (tags.includes("homerun")) {
    massagedTags.add("homerun");
  } // Pitcher


  if (tags.includes("pitcher")) {
    massagedTags.add("pitcher");
  } // Out


  if (tags.includes("out")) {
    massagedTags.add("out");
  }

  return Array.from(massagedTags);
};

exports.massageTagsForSearch = massageTagsForSearch;